<template>
  <div>
    <div id="header-container" class="px-5 in-step">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header" />
      <div class="pt-4 text-white mb-4">
        <h3 class="text-white">{{ $t("Add Beneficiary (Different Name)") }}</h3>
        <span class="fz-16 fw-400"
          >Fill out the form to create new beneficiary</span
        >
      </div>

      <step-container :current_step="2" :step_list="stepList"></step-container>
    </div>

    <b-container fluid class="mt-0 pb-5">
      <div id="body-container" class="px-4 pt-3">
        <b-row>
          <b-col cols="12">
            <h5 class="mb-4">Bank Info</h5>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Partner type") }}
                <span class="text-danger">*</span></label
              >
              <Select2
                v-model="params.accType"
                :options="accTypeOpt"
                @select="onSelectType($event)"
                :settings="{
                  escapeMarkup: doEscapeMarkup,
                  placeholder: $t('Partner Type'),
                }"
                class="form-control"
              />
              <div
                v-if="error['accType']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["accType"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Swift Code") }}
                <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="params.swiftCode"
                @keyup="onChange('swiftCode')"
              />
              <div
                v-if="error['swiftCode']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["swiftCode"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Account Name") }}
                <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="params.accountName"
                @keyup="onChange('accountName')"
              />
              <div
                v-if="error['accountName']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["accountName"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Bank code") }} <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="params.clearingCode"
                @keyup="onChange('clearingCode')"
              />
              <div
                v-if="error['clearingCode']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["clearingCode"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Card Number") }}
                <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="params.cardNo"
                @keyup="onChange('cardNo')"
              />
              <div v-if="error['cardNo']" class="invalid-feedback d-block mb-3">
                {{ $t(error["cardNo"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Bank Name") }} <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="params.bankName"
                @keyup="onChange('bankName')"
              />
              <div
                v-if="error['bankName']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["bankName"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Account Type") }}
                <span class="text-danger">*</span></label
              >
              <Select2
                v-model="params.cardType"
                :options="cardTypeOpt"
                @select="onSelectCardType($event)"
                :settings="{
                  escapeMarkup: doEscapeMarkup,
                  placeholder: $t('Account Type'),
                }"
                class="form-control"
              />
              <div
                v-if="error['cardType']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["cardType"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Bank Branch Name") }}
                <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="params.bankBranchName"
                @keyup="onChange('bankBranchName')"
              />
              <div
                v-if="error['bankBranchName']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["bankBranchName"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Account Currency") }}
                <span class="text-danger">*</span></label
              >
              <Select2
                v-model="params.accountCcy"
                :options="accountCcyOpt"
                @select="onChange('accountCcy')"
                :settings="{
                  escapeMarkup: doEscapeMarkup,
                  placeholder: $t('Select Currency'),
                }"
                class="form-control"
              />
              <div v-if="error.accountCcy" class="invalid-feedback d-block">
                {{ $t(error.accountCcy) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Country") }} <span class="text-danger">*</span></label
              >
              <Select2
                v-model="params.countryCode"
                :options="countryCodeOpt"
                @select="onSelectCountry($event)"
                :settings="{
                  escapeMarkup: doEscapeMarkup,
                  placeholder: $t('Country'),
                }"
                class="form-control"
              />
              <div
                v-if="error['countryCode']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["countryCode"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Payment Methods") }}
                <span class="text-danger">*</span></label
              >
              <div class="d-flex">
                <span v-for="item in paymentChannelTypeOpt" class="px-2">
                  <input
                    type="radio"
                    :value="item.value"
                    :id="item.value"
                    name="paymentChannelType"
                    v-model="params.paymentChannelType"
                    class="mr-1"
                    @change="onChange('paymentChannelType')"
                  />
                  <label :for="item.value">{{ item.text }}</label>
                </span>
              </div>
              <div
                v-if="error['paymentChannelType']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["paymentChannelType"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label
                >{{ $t("Bank Address") }}
                <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="params.bankAddress"
                @keyup="onChange('bankAddress')"
                @keypress="validateInput($event)"
              />
              <div
                v-if="error['bankAddress']"
                class="invalid-feedback d-block mb-3"
              >
                {{ $t(error["bankAddress"]) }}
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-5 mt-5">
          <b-col cols="12" class="d-flex">
            <button
              @click="$router.go(-1)"
              class="btn btn-previous d-block mr-auto"
            >
              {{ $t("Previous") }}
            </button>
            <button @click="doSubmit" class="btn btn-primary d-block">
              {{ $t("Next") }}
            </button>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import LoaderComponent from "@/components/LoaderComponent";
import Select2 from "v-select2-component";
import CreateAccount from "@/services/CreateAccount";
import Common from "@/services/Common";
import Withdrawal from "@/services/Withdrawal";
import stepContainer from "@/components/CardManagement/stepContainer";

export default {
  name: "partner-bank-info",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      userNo: "",
      isLoading: false,
      optional: [],
      accountCcyOpt: [],
      countryCodeOpt: [],
      currentCountryCode: "",
      paymentChannelTypeOpt: [{ value: "SWIFT", text: "SWIFT" }],
      currentCountry: "",
      accTypeOpt: [
        { text: "Business", id: 1 },
        { text: "Individual", id: 2 },
      ],
      cardTypeOpt: [
        { text: "DEPOSIT", id: 10 },
        { text: "SAVING", id: 11 },
        { text: "CHECKING", id: 12 },
      ],
      stepList: ["Beneficiary Info", "Bank Info", "Beneficiary Summary"],
      params: {
        accType: "",
        accountName: "",
        cardNo: "",
        paymentChannelType: "",
        bankName: "",
        bankBranchName: "",
        countryCode: "",
        accountCcy: "",
        swiftCode: "",
        bankAddress: "",
        clearingCode: "",
        cardType: "",
      },
      error: {
        accType: "",
        accountName: "",
        payeeAddress: "",
        cardNo: "",
        paymentChannelType: "",
        bankName: "",
        bankBranchName: "",
        countryCode: "",
        accountCcy: "",
        countryCode: "",
        swiftCode: "",
        bankAddress: "",
        clearingCode: "",
        cardType: "",
      },
    };
  },
  components: {
    LoaderComponent,
    Select2,
    stepContainer,
  },
  methods: {
    validateInput(event) {
      const allowedChars = /^[a-zA-Z0-9 _-]$/;
      const char = String.fromCharCode(event.which);

      if (!allowedChars.test(char)) {
        event.preventDefault();
        return false;
      }
    },
    onChange(key) {
      this.error[key] = "";
    },
    getCountry() {
      let self = this;
      this.accountCcyOpt = [];
      Common.countries().then((response) => {
        if (response.status == 200 && response.data.success) {
          const countries = response.data.data;

          for (let i = 0; i < countries.length; i++) {
            const flag =
              '<span class="fi fi-' +
              countries[i]["iso2"].toLowerCase() +
              '"></span>';
            const country_name =
              "<span>" + this.$t(countries[i]["name"]) + "\t\t\t" + "</span>";

            if (this.params.countryCode == countries[i]["iso2"]) {
              this.currentCountry = countries[i]["name"];
              this.currentCountryCode = countries[i]["iso3"];
            }

            const existingItem = this.accountCcyOpt.find(
              (item) => item.id === countries[i]["currency"]
            );
            if (!existingItem) {
              this.accountCcyOpt.push({
                id: countries[i]["currency"],
                text:
                  countries[i]["currency"] +
                  " - " +
                  countries[i]["currency_name"],
              });
            }

            self.countryCodeOpt.push({
              id: countries[i]["iso2"],
              text: flag + country_name,
              name: countries[i]["name"],
              iso3: countries[i]["iso3"],
            });
          }
        }
      });
    },
    doEscapeMarkup(markup) {
      return markup;
    },
    onSelectCountry({ name, iso3 }) {
      this.currentCountryCode = iso3;
      this.currentCountry = name;
      this.error.countryCode = "";
    },
    onSelectCardType() {
      this.error.cardType = "";
    },
    onSelectType() {
      this.error.accType = "";
    },
    getUser() {
      let self = this;
      CreateAccount.list().then((response) => {
        if (response.status == 200) {
          let account = response.data.data;
          if (account) {
            account.forEach((element) => {
              if (element.status == 2) {
                self.userNo = element.userNo;
              }
            });
          }
        }
      });
    },
    validate() {
      let success = true;
      let self = this;
      Object.keys(this.params).forEach(function (key) {
        if (!self.params[key] && !self.optional.includes(key)) {
          self.error[key] = "can not be blank.";
          success = false;
        }
      });

      return success;
    },
    doSubmit() {
      let self = this;

      if (this.validate()) {
        let bank_info = {
          accType: this.params.accType,
          accountCcy: this.params.accountCcy,
          accountName: this.params.accountName,
          userNo: this.userNo,
          paymentChannelType: this.params.paymentChannelType,
          countryName: this.currentCountry,
          countryCode: this.params.countryCode,
          countryCodeIso3: this.currentCountryCode,
          cardNo: this.params.cardNo,
          bankName: this.params.bankName,
          bankBranchName: this.params.bankBranchName,
          swiftCode: this.params.swiftCode,
          bankAddress: this.params.bankAddress,
          clearingCode: this.params.clearingCode,
          cardType: this.params.cardType,
        };

        localStorage.setItem("bank_info", JSON.stringify(bank_info));

        this.$router.push({
          path: "add-partner-summary",
        });
      }
    },
    getMessage: function (key) {
      return this.$t(key);
    },
    checkError(err) {
      this.isLoading = false;
      const response = err.response;
      console.log("===================");
      let self = this;
      if (response.status == 400) {
        console.log(response.data);
        if (typeof response.data.message === "string") {
          this.$swal({
            icon: "info",
            html: response.data.message,
            showConfirmButton: true,
            confirmButtonText: self.getMessage("OK"),
          });
        } else {
          if (response.data.message["errorMsg"]) {
            this.$swal({
              icon: "info",
              html: response.data.message["errorMsg"],
              showConfirmButton: true,
              confirmButtonText: self.getMessage("OK"),
            });
          } else {
            let ret = [];
            Object.keys(response.data.message).forEach((key) => {
              ret.push(response.data.message[key][0]);
            });

            this.$swal({
              icon: "info",
              html: ret.join("<br>"),
              showConfirmButton: true,
              confirmButtonText: self.getMessage("OK"),
            });
          }
        }
      } else if (
        response.status == 401 &&
        response.data.name == "Unauthorized"
      ) {
        localStorage.removeItem("token");
        localStorage.removeItem("member");
        localStorage.removeItem("isFirstTime");
        this.$router.push({
          path: "/login",
        });
      } else {
        if (localStorage.getItem("token")) {
          var msg = response.data ? response.data.message : err.message;
          this.$notify({
            type: "warn",
            text: msg,
          });
        }
      }
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      self.getUser();

      let bank_info = localStorage.getItem("bank_info");
      if (bank_info) {
        bank_info = JSON.parse(bank_info);
        Object.keys(this.params).forEach((key) => {
          self.params[key] = bank_info[key];
        });
      }

      self.getCountry();
    });
  },
};
</script>
